import React from 'react';

export default function Component(props) {

    const handleSearchChange = (e) => {
        props.handleSearch(e.target.value);
    };

    const handleProtocolChange = (e) => {
        props.handleProtocol(e.target.value);
    }

    return(
    <div className='inline-flex items-center w-full md:w-1/3'>
        <div className="group inline-flex items-center justify-center focus-within:ring focus-within:ring-indigo-500 transition ease-in-out duration-300 w-42 h-10 mx-3 md:mx-10 my-3 px-2 border border-gray-400 rounded-lg">
            <svg width="24" height="24" fill="none" className="text-gray-400 group-hover:text-gray-500 transition-colors duration-200"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
            <input 
                className="focus:outline-none px-2 mx-2" 
                placeholder="Search"
                value={ props.search }
                onChange={ handleSearchChange }
            />
        </div>
        <div className='w-full md:w-1/3 mx-3 md:mx-1'>
            <select 
                id="protocol" 
                name="protocol" 
                autoComplete="off" 
                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                required
                onChange={ handleProtocolChange }
            >
                <option>plot</option>
                <option>co2</option>
            </select>
        </div>
    </div>
    );
}

